module.exports = __webpack_public_path__ + "img/p-9.7091a9ca.jpg";